import { t as e } from "../_rolldown_dynamic_import_helper-D-UeDQjf.js";
//#region src/loaders/backoffice.ts
var t = (t) => e(/* #__PURE__ */ Object.assign({
	"../translations/backoffice/en-GB.json": () => import("../en-GB-CDLRuB3n.js").then((e) => e.n),
	"../translations/backoffice/fr-BE.json": () => import("../fr-BE-DVSin0ri.js").then((e) => e.n),
	"../translations/backoffice/it-IT.json": () => import("../it-IT-DX2SjAIM.js").then((e) => e.n),
	"../translations/backoffice/nl-BE.json": () => import("../nl-BE-BtHAxZl6.js").then((e) => e.n),
	"../translations/backoffice/nl-NL.json": () => import("../nl-NL-CTF3eCAt.js").then((e) => e.n)
}), `../translations/backoffice/${t}.json`, 4).then((e) => e.default);
//#endregion
export { t as loadTranslations };

//# sourceMappingURL=backoffice.loader.js.map